import React from "react";
import { Route, Navigate } from "react-router-dom";
import MainLayout from "../../components/MainLayout/MainLayout";
import { AuthenticationGuard } from "../../components/AuthenticationGuard/AuthenticationGuard";
import PermissionGuard from "../../components/PermissionGuard/PermissionGuard";
import ErrorBoundaryWithFallback from "../../components/ErrorBoundary/ErrorBoundaryWithFallback";
import TranscriptErrorFallback from "@/modules/transcripts/components/TranscriptErrorBoundary";

// Lazy-loaded route components
const CallScoringTable = React.lazy(
  () =>
    import(
      "@/modules/transcripts/features/CallScoring/components/CallScoringTable/CallScoringTable"
    ),
);
const CallCoachingDashboard = React.lazy(
  () =>
    import(
      "@/modules/transcripts/features/CallScoring/components/CallCoachingDashboard/CallCoachingDashboard"
    ),
);
const NotificationRecipientsPage = React.lazy(
  () =>
    import(
      "@/modules/transcripts/features/NotificationRecipients/components/NotificationRecipientsPage"
    ),
);
const CallScoringSettingsPage = React.lazy(
  () =>
    import(
      "@/modules/transcripts/features/CallScoringSettings/components/CallScoringSettingsPage"
    ),
);
const EmailTemplateSettingsPage = React.lazy(
  () =>
    import(
      "@/modules/transcripts/features/EmailTemplateSettings/components/EmailTemplateSettingsPage"
    ),
);

/**
 * TranscriptRoutes
 *
 * Wraps the /transcripts section in the Auth0-based authentication guard
 * and restricts access to SUPER ADMIN users only
 */
const TranscriptRoutes = (
  <Route
    element={
      <AuthenticationGuard
        component={() => <MainLayout section="transcripts" />}
      />
    }
    path="/transcripts"
  >
    <Route
      element={<Navigate replace to="/transcripts/call-scoring" />}
      index
    />
    <Route
      element={
        <PermissionGuard requiredRoles={["ROLE_SUPER_ADMIN"]}>
          <ErrorBoundaryWithFallback fallback={TranscriptErrorFallback}>
            <CallScoringTable />
          </ErrorBoundaryWithFallback>
        </PermissionGuard>
      }
      path="call-scoring"
    />
    <Route
      element={
        <PermissionGuard requiredRoles={["ROLE_SUPER_ADMIN"]}>
          <ErrorBoundaryWithFallback fallback={TranscriptErrorFallback}>
            <CallCoachingDashboard />
          </ErrorBoundaryWithFallback>
        </PermissionGuard>
      }
      path="call-scoring/:callId"
    />
    <Route
      element={
        <PermissionGuard requiredRoles={["ROLE_SUPER_ADMIN"]}>
          <ErrorBoundaryWithFallback fallback={TranscriptErrorFallback}>
            <NotificationRecipientsPage />
          </ErrorBoundaryWithFallback>
        </PermissionGuard>
      }
      path="notification-recipients"
    />
    <Route
      element={
        <PermissionGuard requiredRoles={["ROLE_SUPER_ADMIN"]}>
          <ErrorBoundaryWithFallback fallback={TranscriptErrorFallback}>
            <CallScoringSettingsPage />
          </ErrorBoundaryWithFallback>
        </PermissionGuard>
      }
      path="scoring-settings"
    />
    <Route
      element={
        <PermissionGuard requiredRoles={["ROLE_SUPER_ADMIN"]}>
          <ErrorBoundaryWithFallback fallback={TranscriptErrorFallback}>
            <EmailTemplateSettingsPage />
          </ErrorBoundaryWithFallback>
        </PermissionGuard>
      }
      path="email-template"
    />
  </Route>
);

export default TranscriptRoutes;
